export default __webpack_public_path__ + "static/media/Stake.b66a2fc3.svg";